import React from 'react';
import { Grid, Paper, Typography } from '@mui/material';
import AreaChartWidget from '../widgets/AreaChartWidget';
import BreakdownWidget from '../widgets/BreakdownWidget';
import BoxViolinWidget from '../widgets/BoxViolinWidget';
import FunnelWidget from '../widgets/FunnelWidget';
import HeatmapWidget from '../widgets/HeatmapWidget';
import HistogramWidget from '../widgets/HistogramWidget';
import KpiDeltaWidget from '../widgets/KpiDeltaWidget';
import MetricCardWidget from '../widgets/MetricCardWidget';
import MovingAverageWidget from '../widgets/MovingAverageWidget';
import ScatterBubbleWidget from '../widgets/ScatterBubbleWidget';
import SmallMultiplesWidget from '../widgets/SmallMultiplesWidget';
import StackedBarWidget from '../widgets/StackedBarWidget';
import TrendLineWidget from '../widgets/TrendLineWidget';
import { WidgetCard, WidgetEmptyState } from '../widgets/WidgetCard';

const renderWidget = (widget, metrics, rows) => {
  const safeRows = Array.isArray(rows) ? rows : [];
  const metric = metrics?.[widget.params?.metricId];
  if (widget.type === 'metric_card') return <MetricCardWidget widget={widget} metric={metric} />;
  if (widget.type === 'trend_line') return <TrendLineWidget widget={widget} metric={metric} />;
  if (widget.type === 'breakdown') return <BreakdownWidget widget={widget} metric={metric} />;
  if (widget.type === 'stacked_bar') return <StackedBarWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'percent_stacked_bar') return <StackedBarWidget widget={widget} rows={safeRows} normalize />;
  if (widget.type === 'area_chart') return <AreaChartWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'stacked_area_chart') return <AreaChartWidget widget={widget} rows={safeRows} stacked />;
  if (widget.type === 'moving_average_line') return <MovingAverageWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'histogram') return <HistogramWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'heatmap') return <HeatmapWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'funnel') return <FunnelWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'scatter') return <ScatterBubbleWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'bubble') return <ScatterBubbleWidget widget={widget} rows={safeRows} bubble />;
  if (widget.type === 'box_plot') return <BoxViolinWidget widget={widget} rows={safeRows} />;
  if (widget.type === 'violin_plot') return <BoxViolinWidget widget={widget} rows={safeRows} variant="violin" />;
  if (widget.type === 'kpi_delta') return <KpiDeltaWidget widget={widget} metric={metric} metrics={metrics} />;
  if (widget.type === 'small_multiples') return <SmallMultiplesWidget widget={widget} rows={safeRows} />;
  return (
    <WidgetCard title={widget.params?.title || widget.type} subtitle="Unsupported widget">
      <WidgetEmptyState message="This widget type is not yet supported in the Phase 2 UI shell." />
    </WidgetCard>
  );
};

const ReportWidgetsGrid = ({ widgets, metrics, rows }) => {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 3 }}>
      <Typography variant="subtitle1" sx={{ fontWeight: 600, mb: 2 }}>
        Dashboard widgets
      </Typography>
      {widgets.length === 0 ? (
        <Typography variant="body2" color="text.secondary">
          No widgets configured for this report.
        </Typography>
      ) : (
        <Grid container spacing={2}>
          {widgets.map((widget) => (
            <Grid item xs={12} md={6} key={widget.id || `${widget.type}-${widget.params?.title || ''}`}>
              {renderWidget(widget, metrics, rows)}
            </Grid>
          ))}
        </Grid>
      )}
    </Paper>
  );
};

export default ReportWidgetsGrid;
